import { Gym } from 'fitbeat.models';
import { WorkoutType } from '../../config/workouttype';
import { Side, Zone } from './../gymschedule/zone';
import { UserExerciseSession } from './../workoutsession/userexercisesession';

export class GymState {
  public readonly stateTime: Date;
  public readonly endTime: Date;
  public readonly sessions: UserExerciseSession[]; // use size of array to infer amount of stations

  constructor(stateTime: Date, endTime: Date, sessions: UserExerciseSession[]) {
    this.stateTime = stateTime;
    this.endTime = endTime;
    this.sessions = sessions;
  }

  public firstFreeStation(): number {
    // return this.sessions.findIndex(s => s instanceof EmptySession);-find does not work, need to ensure first find
    for (let i = 0; i < this.sessions.length; i++) {
      if (this.sessions[i].isEmpty()) {
        return i;
      }
    }
    return -1;
  }

  public hasFreeStation(): boolean {
    return this.sessions.find((s) => s.isEmpty()) != null;
  }

  public firstFreeZoneFirstStation(): number {
    for (let i = 0; i < this.sessions.length; i += 2) {
      if (this.sessions[i].isEmpty()
        && this.sessions[i + 1].isEmpty()) {
        return i;
      }
    }
    return -1;
  }

  public hasFreeZone(): boolean {
    return this.firstFreeZoneFirstStation() !== -1;
  }

  public isFreeStation(stationNumber: number): boolean {
    return this.sessions[stationNumber].isEmpty();
  }

  public stationBelongsToSpecifiedWorkoutSession(stataionNumber: number, sessionReference?: string): boolean {
    if (!sessionReference) {
      return false;
    }
    return (!this.isFreeStation(stataionNumber) &&
      this.sessions[stataionNumber].parentWorkoutSession.uniqueReference === sessionReference);
  }

  // One line description, useful for logging/diagnosis
  public description(gym: Gym): string {
    let stationsString = 'Stations:';
    for (let i = 0; i < this.sessions.length; i++) {
      stationsString +=
        ' Z' +
        (Zone.zoneForStation(i, gym).numberInGym) +
        '-' +
        (Zone.zoneForStation(i, gym).side === Side.Right ? 'R' : 'L') +
        ':';
      if (!this.sessions[i].isEmpty()) {
        const userexercisesession = this.sessions[i] as UserExerciseSession;
        stationsString += userexercisesession.parentWorkoutSession.userProfileId;
        stationsString +=
          '-' + (userexercisesession.workoutStage);
      }
    }
    return 'Time: ' + this.stateTime.toTimeString() + ' ' + stationsString;
  }

  public capacity(workoutType?: WorkoutType): number {
    let countFull: number = 0;
    this.sessions.forEach((session: UserExerciseSession) => {
      if (!(session.isEmpty())) {
        if (!workoutType || (workoutType && session.parentWorkoutSession.workoutType === workoutType)) {
          countFull++;
        }
      }
    });

    return countFull / this.sessions.length;
  }
}
